﻿import { renderCounterComponent, counterComponent, conversionsModalsComponent, onSuccessSignInOnConvert, rerenderMenu } from '../site.js';

const CONSTANTS = {
    cookies: "/login?useCookies=true",
    sessionCookies: "/login?useSessionCookies=true"
};

const SELECTORS = Object.freeze({
    emailField: ".js-email-input",
    passwordField: ".js-password-field",
});

const MESSAGES = Object.freeze({
    required: "This field is required.",
    invalidEmail: "The Email field is not a valid e-mail address.",
});

function isFieldValid(value) {
    return value.trim() !== '';
}

function validateField(field, selector, errorMessage) {
    if (!field) return false;
    const isValid = isFieldValid(field.value);
    renderFieldErrorMessage(selector, isValid ? '' : errorMessage);
    toggleFieldsValidation(field, isValid);
    return isValid;
}

export function getFormValues(form) {
    return {
        email: form.querySelector('#Email').value, // TODO: Verify .toLowerCase() is safe
        password: form.querySelector('#Password').value,
        useCookies: form.querySelector('#RememberMe')?.checked || false
    };
}

export function checkforEmptyFields(options = {}) {
    const {
        passwordSelector = SELECTORS.passwordField,
        errorMessage = MESSAGES.required
    } = options;

    const passwordField = document.querySelector(passwordSelector);

    let isPasswordValid = true;

    if (passwordField ) {
        const isPasswordEmpty = !isFieldValid(passwordField.value);

        if (isPasswordEmpty) {
            renderFieldErrorMessage(passwordSelector, errorMessage);
            toggleFieldsValidation(passwordField, false);
            isPasswordValid = false;
        }
    } else {
        isPasswordValid = passwordField ? validateField(passwordField, passwordSelector, errorMessage) : true;
    }

    return isPasswordValid;
}

export function renderFieldErrorMessage(fieldSelector, message) {
    const field = document.querySelector(fieldSelector);
    if (!field) return;

    const inputContainer = field.closest('.form__input__container');
    const inputWrapper = inputContainer.querySelector('.form__input__wrapper');
    if (!inputContainer || !inputWrapper) return;

    let errorContainer = inputContainer.querySelector('.field-error-message');
    if (!errorContainer) {
        errorContainer = document.createElement('div');
        errorContainer.className = 'field-error-message text-danger';
        inputContainer.insertBefore(errorContainer, inputWrapper.nextSibling);
    }

    errorContainer.textContent = message;
    errorContainer.classList.toggle('active', !!message);
}

export function validateEmailField(emailFieldSelector) {
    const emailField = document.querySelector(emailFieldSelector);
    if (!emailField) return false;

    const isValid = emailField.checkValidity();
    renderFieldErrorMessage(emailFieldSelector, isValid ? '' : MESSAGES.invalidEmail);
    toggleFieldsValidation(emailField, isValid);
    return isValid;
}

export function toggleFieldsValidation(fields, state) {
    const fieldArray = Array.isArray(fields) || fields instanceof NodeList ? fields : [fields];
    fieldArray.forEach(field => {
        if (!field) return;
        field.classList.toggle('input-validation-error', !state);
    });
}

export function isFormValid(form, options = {}) {
    const { shouldValidate = true, validateEmail = true } = options;
    if (!form) return false;

    form.classList.add('was-validated');


    //Clean errors
    [SELECTORS.emailField, SELECTORS.passwordField].forEach(selector => {
        const field = form.querySelector(selector);
        if (field) {
            renderFieldErrorMessage(selector, '');
            toggleFieldsValidation(field, true);
        }
    });

    if (!shouldValidate) {
        return form.checkValidity();
    }

    const hasEmptyFields = !checkforEmptyFields();

    const isEmailInvalid = validateEmail && !validateEmailField(SELECTORS.emailField);

    const isFormInvalid = !form.checkValidity();
    const hasInvalidFields = form.querySelector('.is-invalid');

    return !(hasEmptyFields || isEmailInvalid || isFormInvalid || hasInvalidFields);
}

export function clearTextContent(selector) {
    const element = document.querySelector(selector);
    if (element) element.textContent = '';
}

export function startEmailValidationProcess() {
    validateEmailField(SELECTORS.emailField);
    const emailField = document.querySelector(SELECTORS.emailField);
    if (emailField && !emailField.dataset.listenerAdded) {
        emailField.addEventListener('input', () => validateEmailField(SELECTORS.emailField));
        emailField.dataset.listenerAdded = 'true';
    }
}

function showUserEmail(email, selector = '.js-user-email') {
    if (!email) return;

    const userEmailBlock = document.querySelector(selector);
    if (!userEmailBlock) {
        console.error("User email block not found.");
        return;
    }

    let emailContainer = userEmailBlock.querySelector('.user-email');
    if (!emailContainer) {
        emailContainer = document.createElement('span');
        emailContainer.classList.add('user-email', 'user-data__mail');
        userEmailBlock.appendChild(emailContainer);
    }

    emailContainer.textContent = email;
}

function getLoginUrl(useCookies) {
    return useCookies ? CONSTANTS.cookies : CONSTANTS.sessionCookies;
}



async function onSuccessSignIn(email, containerSelector, onSuccess, data) {
    isUserLoggedIn = true;
    enableControls(containerSelector);


    if (!counterComponent || !conversionsModalsComponent) {
        await renderCounterComponent();
    }

    showUserEmail(email.toLowerCase());

    if (window.allowRenderOnLogin) {
        onSuccessSignInOnConvert();
        rerenderMenu(".account-actions__menu", "/Home/Index");
    }

    if (typeof onSuccess === "function") {
        onSuccess(data);
    }
}

function onErrorSignIn(xhr, form) {
    let message;
    const loginNotMatched = xhr.responseJSON && xhr.responseJSON.status === 401;
    if (loginNotMatched) {
        message = "Login failed. Please check your username and password.";
        const fieldsToMark = form.querySelectorAll(".js-on-error");
        toggleFieldsValidation(fieldsToMark, false);
    } else {
        message = xhr.responseJSON?.message || "Failed. An error has occurred";
    }

    document.querySelector("#errors-message").textContent = message;
}

function enableControls(containerSelector) {
    $(containerSelector).find("button").prop("disabled", false);
    $(containerSelector).find("input").prop("disabled", false);
}

export function okClickSingIn(containerSelector, onSuccess) {
    clearTextContent("#errors-message");

    const form = document.querySelector('.js-user-info-form');
    if (!form) {
        console.error("Form not found.");
        return;
    }

    form.classList.add('was-validated');
    const isValid = isFormValid(form, { shouldValidate: true, validateEmail: true });

    if (!isValid) {
        startEmailValidationProcess();
        return;
    }

    const { email, password, useCookies } = getFormValues(form);
    const loginUrl = getLoginUrl(useCookies);

    enableControls(containerSelector);

    $.ajax({
        url: loginUrl,
        data: JSON.stringify({ email, password }),
        processData: false,
        contentType: "application/json",
        type: "POST",
        success: async function (data) {
            await onSuccessSignIn(email, containerSelector, onSuccess, data);
        },
        error: function (xhr) {
            onErrorSignIn(xhr, form);
        }
    });
}